__turbopack_context__.v({
  "component": "style-module-scss-module__WDSlZq__component",
  "text": "style-module-scss-module__WDSlZq__text",
});
